export default {
  clearSession: 'MAIN_ACTIONS_CLEAR_SESSION',
  fill: 'MAIN_ACTIONS_FILL',
  setInformation: 'MAIN_ACTIONS_SETINFORMATION'
}
